import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export interface UpdateCalendarVacationPayload {
  calendarVacationId: number;
  title: string;
  description: string;
  startDate: Date | null;
  endDate: Date | null;
}

export const updateCalendarVacationOperation = async (
  payload: UpdateCalendarVacationPayload,
  setLoading: (isLoading: boolean) => void,
  onClose: () => void,
) => {
  try {
    const title = payload.title?.trim();
    if (!title) {
      toast.warn('יש להזין כותרת');
      return;
    }
    if (title.length > 50) {
      toast.warn('כותרת חייבת להיות עד 50 תווים');
      return;
    }
    if ((payload.description ?? '').length > 255) {
      toast.warn('תיאור חייב להיות עד 255 תווים');
      return;
    }

    setLoading(true);
    await appApi.updateCalendarVacation(payload.calendarVacationId, {
      title,
      description: payload.description ?? '',
      startDate: payload.startDate,
      endDate: payload.endDate,
    });
    await globalSettingsStores.fetchSetting();
    toast.success('החופשה עודכנה בהצלחה');
    onClose();
  } catch (e) {
    toast.error('עדכון החופשה נכשל, נסה שוב בעוד מספר רגעים');
    console.error(`updateCalendarVacationOperation failed: ${e}`);
  } finally {
    setLoading(false);
  }
};
